import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import { IUserInfo } from '../models/user.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { TrackingData } from './tracking';
import { UtilitiesProvider } from './utilities';
import { ENV } from '@app/env';
import * as firebase from 'firebase';
import moment from 'moment';
import { Observable } from 'rxjs';
import { _ACTIONS } from './analytics';

@Injectable()

export class AuthData {

  fireAuth: any;
  clientId = ENV.client;

  constructor(
    public afAuth: AngularFireAuth,
    public database: AngularFireDatabase,
    public trackingData: TrackingData,
    private utilities: UtilitiesProvider,
    private http: HttpClient
  ) {
    this.afAuth.authState.subscribe(user => {
      if (user) {
        this.fireAuth = user;
      }
    });
  }

  get defaultTemplateNotificationNewGuestClub() {
    // tslint:disable-next-line:max-line-length
    return "https://firebasestorage.googleapis.com/v0/b/rebus-v4-prod.appspot.com/o/Mails%2FtemplatenotificationNewGuest.html%20.html?alt=media&token=17636f1d-e22a-4c62-b183-b402a2de2bc7";
  }

  get defaultTemplateNotificationNewEntrySocio() {
    // tslint:disable-next-line:max-line-length
    return "https://firebasestorage.googleapis.com/v0/b/rebus-v4-prod.appspot.com/o/templates%2FtemplateNotificationNewEntrySocio.html?alt=media&token=d0641011-30ff-4195-8986-d9823c2bc64e";
  }

  get defaultTemplateNotificationGuest() {
    // tslint:disable-next-line:max-line-length
    return "https://firebasestorage.googleapis.com/v0/b/rebus-v4-prod.appspot.com/o/Mails%2FtemplateNotificationGuest.html?alt=media&token=b2473957-549d-4662-8571-8108b01359c9";
  }

  getUser() {
    return this.fireAuth;
  }

  public getLocalUser() {
    return this.afAuth.authState
      .map(user => { if (user) return user; else throw Error('Not local user') });
  }

  public getUserDB(uid: string, clientId: string) {
    return this.database.object<IUserInfo>(`/Clients/${clientId}/Users/${uid}`).valueChanges();
  }

  public getUserdb(email) {
    return this.database.list('/Users', ref => ref.orderByChild('email').equalTo(email))
      .valueChanges();
  }

  public loginSocialCustom(userData: any, clientAuth: 'rebus' | 'zeus'): Observable<any> {
    switch (clientAuth) {
      case 'rebus':
        return this.loginSocialCustomRebus(userData);
      case 'zeus':
        return this.loginSocialCustomZeus(userData);
    }
  }

  public loginEmailCustom(userData: { email: string, password: string }, clientAuth: 'rebus' | 'zeus'): Observable<any> {
    switch (clientAuth) {
      case 'rebus':
        return this.loginEmailCustomRebus(userData);
      case 'zeus':
        return this.loginEmailCustomZeus(userData);
    }
  }

  public loginRegisterCustom(userData: any, clientAuth: 'rebus' | 'zeus'): Observable<any> {
    switch (clientAuth) {
      case 'rebus':
        return this.loginRegisterCustomRebus(userData);
      case 'zeus':
        return this.loginRegisterCustomZeus(userData);
    }
  }

  private loginSocialCustomRebus(userSocialData: any): Observable<any> {
    return this.http.post(`${ENV.backend}/auth/social`, { user: userSocialData, client: ENV.client });
  }

  private loginEmailCustomRebus(userData: { email: string, password: string }): Observable<any> {
    return this.http.post(`${ENV.backend}/auth/email`, { email: userData.email, password: userData.password, client: ENV.client });
  }

  private loginRegisterCustomRebus(userData: any): Observable<any> {
    return this.http.post(`${ENV.backend}/auth/form`, {
      email: userData.email,
      password: userData.password,
      client: ENV.client,
      userData: {
        ...userData,
        password: null,
        confirmPassword: null,
        email: null
      }
    });
  }

  private loginSocialCustomZeus(userSocialData: any): Observable<any> {
    return this.http.post(`${ENV.zeus}/auth/social`, { user: userSocialData, client: ENV.client });
  }

  private loginEmailCustomZeus(userData: { email: string, password: string }): Observable<any> {
    return this.http.post(`${ENV.zeus}/auth/email`, { email: userData.email, password: userData.password, client: ENV.client });
  }

  private loginRegisterCustomZeus(userData: any): Observable<any> {
    return this.http.post(`${ENV.zeus}/auth/form`, {
      accion: userData.accion,
      identificacion: userData.identificacion,
      email: userData.email,
      password: userData.password,
      client: ENV.client,
      userData: {
        ...userData,
        password: null,
        confirmPassword: null,
        email: false
      }
    });
  }

  public loginCustomUser(customToken: string) {
    return this.afAuth.auth.signInWithCustomToken(customToken);
  }

  public anonymousLogin(): any {
    return this.afAuth.auth.signInAnonymously();
  }

  public resetPassword(currentEmail: string, clientAuth: 'rebus' | 'zeus'): Observable<any> {
    if (currentEmail === null) {
      return Observable.of(true)
    }
    switch (clientAuth) {
      case 'rebus':
        return this.http.post(`${ENV.backend}/auth/recovery`, { email: currentEmail, client: ENV.client });
      case 'zeus':
        return this.http.post(`${ENV.zeus}/auth/recovery`, { email: currentEmail, client: ENV.client });
    }
  }

  public restorePassword(restoreData: { token: string, hash_rebus_password: string }, clientAuth: 'rebus' | 'zeus'): Observable<any> {
    switch (clientAuth) {
      case 'rebus':
        return this.http.post(`${ENV.backend}/auth/restart`, {
          token: restoreData.token,
          password: restoreData.hash_rebus_password
        });
      case 'zeus':
        return this.http.post(`${ENV.zeus}/auth/restart`, {
          token: restoreData.token,
          password: restoreData.hash_rebus_password,
        });
    }
  }


  logoutUser() {
    return firebase.auth().signOut();
  }

  getExactUser(uid, client) {
    return firebase.database().ref(`/Clients/${client.url}/Users/${uid}`);
  }

  public getUserBeneficiaries(clientId, userId) {
    return this.database.list<any>(`/Clients/${clientId}/Users/${userId}/UsersBeneficiaries/`).valueChanges();
  }

  public getUserGuest(clientId, userId) {
    return this.database.list<any>(`/Clients/${clientId}/Users/${userId}/UsersGuest/`).valueChanges();
  }

  public setTicketFees(feesId, ticketId, userId) {
    return this.database.object(`/Clients/${this.clientId}/Users/${userId}/fees/${feesId}`).update({
      ticketId: ticketId,
      createTicket: firebase.database.ServerValue.TIMESTAMP
    });
  }

  public createUser(clientId, email, name, accion, id, nameUserTitular) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    return this.http.post(`${ENV.backend}/auth/form`,
      {
        "client": clientId,
        "email": email,
        "password": this.randomStr(),
        "userData": {
          "isNetworking": true,
          "terms": true,
          "interest": false,
          "name": name,
          "accion": accion,
          "identificacion": id
        },
        "sendMail": {
          "userCreate": nameUserTitular
        }
      },
      {
        headers: headers
      });
  }

  public randomStr() {
    let m = 5;
    let s = '', r = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < m; i++) { s += r.charAt(Math.floor(Math.random() * r.length)); }
    return s;
  }

  public saveUserBeneficiaryInUserSocio(clientId, userId, response) {
    return this.database.object(`Clients/${clientId}/Users/${userId}/UsersBeneficiaries/${response.info.id}`).set({
      id: response.info.id,
      created_at: firebase.database.ServerValue.TIMESTAMP
    }).catch((error) => {
      this.utilities.consoleError('Whooops, something happen', error);
    })
  }

  public createGuestClub(userId, clientId, email, name, idGuest, nameSocio, dateVisit) {
    return this.database.object(`Clients/${clientId}/Users/${userId}/UsersGuest/${idGuest}`).set({
      id: idGuest,
      dateVisit: dateVisit,
      email: email,
      name: name,
      nameSocio: nameSocio,
      created_at: firebase.database.ServerValue.TIMESTAMP
    }).catch((error) => {
      this.utilities.consoleError('Whooops, something happen', error);
    })
  }

  // createAccount(email, password) {
  //   return firebase.auth().createUserWithEmailAndPassword(email, password)
  // }

  // public saveUser(user: IUserInfo, clientId: string): Promise<any> {
  //   const newUser: IUserInfo = {
  //     phone: '',
  //     company: '',
  //     position: '',
  //     isNetworking: false,
  //     need: '',
  //     offer: '',
  //     terms: true,
  //     interest: {},
  //     ...user,
  //   }
  //   this.utilities.consoleLog('Newuser', newUser);
  //   return this.database.object(`/Clients/${clientId}/Users/${user.id}`)
  //     .set(newUser)
  //     .then(() => this.trackingData.trackEntity('Users', user.id, clientId, newUser, 'create'))
  //     .then(() => newUser)
  //     .catch(error => {
  //       this.utilities.consoleError('Something big happen', error);
  //     })
  // }

  // public saveZeusUser(user: any, clientId: string): Promise<any> {
  //   const newUser: IUserInfo = {
  //     phone: '',
  //     company: '',
  //     position: '',
  //     isNetworking: false,
  //     need: '',
  //     offer: '',
  //     terms: true,
  //     interest: {},
  //     ...user,
  //   }
  //   this.utilities.consoleLog('Newuser zeus', newUser);
  //   return this.database.object(`/Clients/${clientId}/Users/${user.id}`)
  //     .set(newUser)
  //     .then(() => this.trackingData.trackEntity('Users', user.id, clientId, newUser, 'create'))
  //     .then(() => newUser)
  //     .catch(error => {
  //       this.utilities.consoleError('Something big happen', error);
  //     })
  // }

  updateUser(newData: any, clientId: string, userId: string) {
    return this.database.object(`/Clients/${clientId}/Users/${userId}`).update(newData);
  }

  getUsers(clientId: string) {
    return this.database.list<IUserInfo>(`/Clients/${clientId}/Users`).valueChanges();
  }

  getUsersRef(clientId: string) {
    return this.database.list<IUserInfo>(`/Clients/${clientId}/Users`).query.ref;
  }

  getUserRef(userId) {
    return this.database.object(`/Clients/${this.clientId}/Users/${userId}`).query.ref;
  }

  getUsersEvent(clientId: string, eventId: string) {
    return this.database.list<IUserInfo>(`/Clients/${clientId}/Events/${eventId}/Users`).valueChanges();
  }

  plusClientUserRegisteredStat() {
    return this.database.object(`/Clients/${this.clientId}/stats/user_registered`)
      .query.ref.transaction(val => {
        this.utilities.consoleDecorator('Plus val: ', val);
        if (!val) return 1;
        return val + 1;
      });
  }

  saveInterestByUserId(clientId: string, user: any, interest: any): Promise<any> {
    return this.database.object(`Clients/${clientId}/Users/${user.info.id}/interest`).set(interest)
      .catch((error) => {
        this.utilities.consoleError('Whooops, something happen', error);
      })
  }


  public sendUserPurchaseReceipt(clientId, userId, idPayment, toUsers) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    return this.http.post(`${ENV.backend}/notification/payment`,
      {
        "client": clientId,
        "user": userId,
        "payment": idPayment,
        "to": toUsers
      }, {
        headers: headers
      });
  }

  public changePassword(userId, clientId, newPassword) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    return this.http.post(`${ENV.backend}/auth/update`,
      {
        "id": userId,
        "password": newPassword,
        "client": clientId,
      }, {
        headers: headers
      });
  }

  public sendEmailNotificationNewGuestClub(
    client,
    nameGuest,
    guestId,
    dateVisit,
    titularClub,
    template = this.defaultTemplateNotificationNewGuestClub
  ) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    return this.http.post(`${ENV.backend}/notification/mail`,
      {
        "params": {
          "name_user_guest": nameGuest,
          "name_user_club": titularClub,
          "id_user_guest": guestId,
          "date_visit": dateVisit,
          "name_client": client.name,
          "logo_client": client.style_image_page
        },
        "template": template,
        "to": ["andresdoncel95@hotmail.com", "andresdoncel95@gmail.com"],
        "subjet": "Nuevo Usuario en el Club",
        "from": "noreply@rebus.com.co"
      }
      , {
        headers: headers
      });
  }

  public sendEmailNotificationNewEntrySocio(
    nameUser,
    typeSocio,
    actionUser,
    idUser,
    template = this.defaultTemplateNotificationNewEntrySocio
  ) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    return this.http.post(`${ENV.backend}/notification/mail`,
      {
        "params": {
          "name_user": nameUser,
          "typeSocio": typeSocio,
          "action_user": actionUser,
          "id_user": idUser,
          "date_entry": moment(firebase.database.ServerValue.TIMESTAMP).format('MMM Do YY'),
        },
        "template": template,
        "to": ["andresdoncel95@gmail.com"],
        "subjet": "Ingreso de usuario al Club",
        "from": "noreply@rebus.com.co"
      }
      , {
        headers: headers
      });
  }

  public sendEmailNotificationGuest(
    client,
    nameGuest,
    emailGuest,
    guestId,
    dateVisit,
    titularClub,
    template = this.defaultTemplateNotificationGuest
  ) {
    const headers = new HttpHeaders()
      .set('Content-Type', 'application/json');
    return this.http.post(`${ENV.backend}/notification/mail`,
      {
        "params": {
          "name_user_guest": nameGuest,
          "name_user_club": titularClub,
          "id_user_guest": guestId,
          "date_visit": dateVisit,
          "name_client": client.name,
          "logo_client": client.style_image_page
        },
        "template": template,
        "to": [emailGuest],
        "subjet": "Te han invitado al Club",
        "from": "noreply@rebus.com.co"
      }
      , {
        headers: headers
      });
  }

  // sendNotificationUser(user, reserve, template = this.defaultTemplate) {
  //   const headers = new HttpHeaders()
  //     .set('Content-Type', 'application/json');
  //   return this.http.post(`${ENV.backend}/notification/mail`,
  //     {
  //       "params": {
  //         "nombre_usuario": user.displayName,
  //         "nombre_reserva": reserve.name,
  //         "descripción_reserva": reserve.description,
  //         "valor_reserva": reserve.price
  //       },
  //       "template": template,
  //       "to": [user.email], "subjet": "PRUEBA NOTIFICACION", "from": "contact@heroesfest.co"
  //     }
  //     , {
  //       headers: headers
  //     });
  // }

  // get defaultTemplate() {
  //   return "https://firebasestorage.googleapis.com/v0/b/rebus-v4.appspot.com/o/EmailTemplates%2Frefunde_rebus.html?alt=media&token=2db0e471-7569-4943-9c77-8e5f05e0c6de"
  // }

  /**
   * Esto se invoca al inicio de la app para guardar informacion del usuario
   */
  public saveFirstTrackOnFirestore() {
    const id = window.localStorage.getItem(`${ENV.client}-PROCESS-LOAD`) + '-0';
    const logLevel = ENV.log_level !== '' ? ENV.log_level : 'REBUS';
    const document = {
      id,
      action: _ACTIONS.firstLoad,
      trackingId: window.localStorage.getItem(`${ENV.client}-PROCESS-LOAD`),
      processId: window.localStorage.getItem(`${ENV.client}-PROCESS-LOAD`),
      clientId: ENV.client,
      date: firebase.firestore.FieldValue.serverTimestamp(),
      platform: this.utilities.getInfoUserDevice(),
      payload: null,
    };
    firebase.firestore().collection('trackingUser')
    firebase.firestore().collection('_TRACKING_JOURNEY').doc(logLevel).collection(moment().format('YYYY-MM-DD')).doc(id).set(document);
    if (ENV.mode === 'Development') {
      console.warn(`%c ⇨ ѱ saveFirstTrackOnFirestore ѱ ⇦`, `background: #FFD700; color: black; display: block;`, document);
    }
    return true;
  }
}
// TODO: Add scope for social login functions
// end file



// WEBPACK FOOTER //
// ./src/providers/auth.ts